<template>
  <v-navigation-drawer v-model="drawer" right temporary fixed width="250">
    <v-card flat>
      <v-img
        :aspect-ratio="16 / 9"
        class="white--text"
        src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
        app
      >
        <v-layout pa-2 justify-center align-center column fill-height class="lightbox white--text">
          <v-spacer></v-spacer>
          <v-flex>
            <div class="body-2 text-xs-center">
              <v-avatar class="mb-1" color="white" :size="80">
                <img :src="$imgUrl(avatar)" alt="foto-profil" />
              </v-avatar>
            </div>
          </v-flex>
        </v-layout>
      </v-img>
      <v-card-title style="font-size: 1.1rem; font-weight: 400; line-height: 1.4rem">
        <div>
          <h4 class="mb-0">{{ $getAttr(akun, 'nama') }}</h4>
          <span class="grey--text" style="font-size: 1rem">
            {{ $getAttr(akun, 'email') }}
          </span>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-list flat dense :disabled="!isMulti">
        <v-subheader style="height: 20px" class="primary--text">Hak Akses Anda</v-subheader>
        <v-list-item-group color="primary">
          <v-list-item @click="popup('role')">
            <v-list-item-icon>
              <v-icon>mdi-account-switch</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <span class="caption">{{ fkata(roles || []) }}</span>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-divider></v-divider>
      <v-list flat dense>
        <v-subheader class="primary--text">Akun</v-subheader>
        <v-list-item-group color="primary">
          <v-list-item :to="{ name: 'profil' }">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Profil Saya</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="popup('password')">
            <v-list-item-icon>
              <v-icon>mdi-lock</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Ubah Kata Sandi</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="onLogout">
            <v-list-item-icon>
              <v-icon>mdi-logout-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Keluar</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <!-- popup -->
      <popup-peran ref="role"></popup-peran>
      <password ref="password"></password>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { fkata, arrayFlat } from '@utils/format';
import PopupPeran from '../popup/Perans';
import Password from '../popup/Password';

export default {
  props: ['value'],
  components: {
    PopupPeran,
    Password,
  },
  data() {
    return {
      drawer: false,
    };
  },
  computed: {
    ...mapState('auth', {
      role: (state) => state.role || {},
      akun: (state) => state.akun || {},
    }),

    ...mapGetters('auth', ['isUcm']),

    ...mapState('preferensi', {
      loggedAs: (state) => state.loggedAs || {},
      operators: (state) => (state.preferensi && state.preferensi.operators) || {},
      included: (state) => state.included,
    }),

    roles() {
      return (this.$getRelasi(this.loggedAs, 'roles') || []).map(({ id }) =>
        this.$getAttr(this.$getIncluded('roles', id), 'label')
      );
    },

    isMulti() {
      const operators = arrayFlat((this.operators && Object.values(this.operators)) || []);
      return !!operators.length;
    },

    avatar() {
      return (this.akun && this.$getAttr(this.akun, 'foto_url')) || 'admin.png';
    },
  },
  methods: {
    ...mapActions('auth', ['logout']),

    fkata(array) {
      return fkata(array);
    },

    to(obj) {
      return this.role === 'instansi'
        ? Object.assign({}, obj, {
            params: { id: this.instansiId },
          })
        : obj;
    },
    popup(jenis) {
      this.$refs[jenis].open();
    },
    onSwitch() {
      this.drawer = false;
    },
    onLogout() {
      if (this.isUcm) {
        window.localStorage.clear();
        window.location.href = process.env.VUE_APP_API_URL + `/auth/logout`;
      } else {
        this.$store.commit('SET_LOADING', true);
        this.logout().then(() => {
          this.$router.push({ name: 'login' });
        });
      }
    },
  },
  watch: {
    value(val) {
      this.drawer = val;
    },
    drawer(val) {
      this.$emit('input', val);
    },
  },
};
</script>
